
import React, { useState, useEffect } from 'react';
import { useBranch } from '../../../layouts/BranchContext'; 
import BackButton from '../../../ui/BackButton';
import BadgeIcon from '@mui/icons-material/Badge';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { usePdfSettings } from '../../../layouts/PdfSettingsContext.js';

import {
  Button,
  TextField,
  Tooltip,
  Container,
  Typography,
  InputAdornment,
  Box,
  Table,
  Modal,
  TableBody,
  TableCell,
  TableContainer,
  styled,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
   useTheme,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Search as SearchIcon,
  FileUpload as FileUploadIcon,
  FileDownload as FileDownloadIcon,
  Download as DownloadIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import PrintIcon from '@mui/icons-material/Print';
import { useNavigate } from 'react-router-dom';
import { SketchPicker } from 'react-color';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.3)'
        : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${
    theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.2)'
      : 'rgba(0,0,0,0.2)'
  } transparent`,
}));

const CustomVerticalScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,0.3)'
        : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${
    theme.palette.mode === 'dark'
      ? 'rgba(255,255,255,0.2)'
      : 'rgba(0,0,0,0.2)'
  } transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
    />
  );
});

const Admission = () => {
  const {
    pdfThemeColor,
    pdfTextColor,
    updatePdfThemeColor,
    updatePdfTextColor,
    updateAdmissionPrefix,
    admissionPrefix,
  } = usePdfSettings();

    // Shared theme color used for BOTH the Admission PDF and the ID Card
  const [tempThemeColor, setTempThemeColor] =
    useState(pdfThemeColor);

  const navigate = useNavigate();
  const theme = useTheme();

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const rowsPerPageOptions = [5, 10, 25, 50];

  const [openSnackbar, setOpenSnackbar] =
    useState(false);

  const [snackbarMessage, setSnackbarMessage] =
    useState('');

  const [snackbarSeverity, setSnackbarSeverity] =
    useState('success');

  const [searchQuery, setSearchQuery] =
    useState('');

  const [showDeleteModal, setShowDeleteModal] =
    useState(false);

  const [showAddAdmissionModal, setShowAddAdmissionModal] =
    useState(false);

  const [showEditAdmissionModal, setShowEditAdmissionModal] =
    useState(false);

  const [showViewAdmissionModal, setShowViewAdmissionModal] =
    useState(false);

  const [showImportModal, setShowImportModal] =
    useState(false);

    const [showExportModal, setShowExportModal] =
    useState(false);

  // 'active' = only active students, 'all' = active + inactive
  const [exportType, setExportType] =
    useState('active');

  const [importing, setImporting] =
    useState(false);

  const [exporting, setExporting] =
    useState(false);

  const [downloadingTemplate, setDownloadingTemplate] =
    useState(false);

  const [showSuccessModal, setShowSuccessModal] =
    useState(false);

  const [showUserGuideModal, setShowUserGuideModal] =
    useState(false);

   // Single modal, used for both actions
  const [showThemeColorModal, setShowThemeColorModal] =
    useState(false);

  // 'admission' or 'idcard' — tells the modal what to generate
  const [pdfAction, setPdfAction] =
    useState(null);

  const [selectedAdmission, setSelectedAdmission] =
    useState(null);

  const [cancelAdmission, setCancelAdmission] =
    useState(false);

  const [importFile, setImportFile] =
    useState(null);

  const [admissionData, setAdmissionData] =
    useState([]);

  const [filteredData, setFilteredData] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [userRole, setUserRole] =
    useState(null);

  const [userBranch, setUserBranch] =
    useState(null);

  const [idCardData, setIdCardData] =
    useState(null);


      const { selectedBranchId } = useBranch();

  const [organizationId, setOrganizationId] =
    useState(null);

  // ============================================================
  // STATIC DATA
  // ============================================================

  const staticGenderData = [
    {
      id: 1,
      name: 'Male',
    },
    {
      id: 2,
      name: 'Female',
    },
    {
      id: 3,
      name: 'Other',
    },
  ];

  const staticStatusData = [
    {
      id: 1,
      name: 'Active',
    },
    {
      id: 2,
      name: 'Inactive',
    },
    {
      id: 3,
      name: 'Pending',
    },
  ];

  const staticCourseData = [
    {
      id: 1,
      name: 'Computer Science',
    },
    {
      id: 2,
      name: 'Mathematics',
    },
    {
      id: 3,
      name: 'Physics',
    },
  ];

  // ============================================================
  // FORM DATA
  // ============================================================

  const [formData, setFormData] = useState({
    sendEmail: false,
    sendTestSMS: false,
    direct: false,
    cancelAdmission: false,
    cancellationDate: '',
    reason: '',
    corporate: false,
    admissionCode: '',
    admissionDate: new Date()
      .toISOString()
      .split('T')[0],
    candidateName: '',
    mobileNo: '',
    alternateMobileNo: '',
    gender: '',
    email: '',
    address: '',
    status: '',
    fatherName: '',
    motherName: '',
    qualification: '',
    aadhaarNo: '',
    course: '',
    batches: '',
  });

  // ============================================================
  // GET STORED USER
  // ============================================================

  /*
   * Same pattern as ExpenseEntry:
   *
   * 1. sessionStorage first
   * 2. localStorage fallback
   */
  const getStoredUser = () => {
    if (typeof window === 'undefined') {
      return {};
    }

    try {
      return JSON.parse(
        sessionStorage.getItem('user') ||
        localStorage.getItem('user') ||
        '{}'
      );
    } catch (error) {
      console.error(
        'Unable to read logged-in user:',
        error
      );

      return {};
    }
  };

   // ============================================================
  // FETCH BRANCH DETAILS (school name + logo, for PDFs)
  // ============================================================

   const fetchBranchDetails = async (branchId) => {
    if (!branchId) {
      return { orgName: '', branchName: '', logoUrl: null };
    }

    try {
      const accessToken =
        localStorage.getItem('accessToken') ||
        sessionStorage.getItem('accessToken');

      const response = await axios.get(
        `${API_BASE_URL}/api/master/branch/${branchId}/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const branch = response.data || {};

      return {
        // organization name (used as the big institution title)
        orgName: branch.organization_name || '',

        // branch name (shown in brackets under the org name)
        branchName: branch.name || '',

        logoUrl: branch.image
          ? `${API_BASE_URL}${branch.image}`
          : null,
      };
    } catch (error) {
      console.warn(
        'Failed to fetch branch details:',
        error
      );

      return { orgName: '', branchName: '', logoUrl: null };
    }
  };

  // ============================================================
  // IMAGE URL -> BASE64 (for embedding logos in jsPDF)
  // ============================================================

  const loadImageAsBase64 = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();

      img.crossOrigin = 'anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');

        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = reject;
      img.src = url;
    });

  // ============================================================
  // FETCH ADMISSIONS
  // ============================================================

  const fetchAdmissions = async (
    orgId,
    branchId
  ) => {
    try {
      const accessToken =
        localStorage.getItem('accessToken') ||
        sessionStorage.getItem('accessToken');

      const params = {};

      /*
       * Admission API uses:
       * organization_id
       * branch_id
       */
      if (orgId) {
        params.organization_id = orgId;
      }

      if (branchId) {
        params.branch_id = branchId;
      }

      const response = await axios.get(
        `${API_BASE_URL}/api/admission/admissions/`,
        {
          headers: {
            Authorization:
              `Bearer ${accessToken}`,
          },
          params,
        }
      );

      if (response.status !== 200) {
        throw new Error(
          'Failed to fetch admissions'
        );
      }

      /*
       * IMPORTANT:
       * No extra frontend branch filtering here.
       *
       * Backend already receives branch_id.
       */
      setAdmissionData(
        Array.isArray(response.data)
          ? response.data
          : response.data?.results || []
      );

      setFilteredData(
        Array.isArray(response.data)
          ? response.data
          : response.data?.results || []
      );
    } catch (error) {
      console.error(
        'Failed to fetch admissions:',
        error
      );

      setSnackbarMessage(
        'Failed to fetch admissions'
      );

      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // FETCH BRANCHES + ADMISSIONS
  // ============================================================

  /*
   * Runs:
   * - on mount
   * - when organization changes
   * - when selected branch changes
   *
   * This is the main branch filtering flow.
   */
  useEffect(() => {
    const user = getStoredUser();

    const orgId =
      user?.organization_id ||
      organizationId ||
      null;

        setPage(1);

    fetchAdmissions(
      orgId,
      selectedBranchId || null
    );
  }, [
    organizationId,
    selectedBranchId,
  ]);

  // ============================================================
  // SEARCH FILTER
  // ============================================================

  useEffect(() => {
    setFilteredData(
      admissionData.filter((adm) =>
        String(
          adm?.candidate_name || ''
        )
          .toLowerCase()
          .includes(
            searchQuery.toLowerCase()
          )
      )
    );
  }, [
    searchQuery,
    admissionData,
  ]);

  // ============================================================
  // DELETE
  // ============================================================

  const handleDeleteAdmission =
    async (id) => {
      try {
        const accessToken =
          localStorage.getItem(
            'accessToken'
          ) ||
          sessionStorage.getItem(
            'accessToken'
          );

        const response =
          await axios.delete(
            `${API_BASE_URL}/api/admission/admissions/${id}/`,
            {
              headers: {
                Authorization:
                  `Bearer ${accessToken}`,
              },
            }
          );

        if (
          response.status === 204
        ) {
          setSnackbarMessage(
            'Admission deleted successfully'
          );
        } else if (
          response.status === 200 &&
          response.data?.message?.includes(
            'soft deleted'
          )
        ) {
          setSnackbarMessage(
            'Admission deleted successfully'
          );
        } else {
          throw new Error(
            'Unexpected response'
          );
        }

        setSnackbarSeverity('success');
        setOpenSnackbar(true);

        const user =
          getStoredUser();

        const orgId =
          user?.organization_id ||
          organizationId ||
          null;

        fetchAdmissions(
          orgId,
          selectedBranchId || null
        );
      } catch (error) {
        console.error(
          'Delete failed:',
          error
        );

        const msg =
          error?.response?.data?.message ||
          'Failed to delete admission';

        setSnackbarMessage(msg);
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
      } finally {
        setShowDeleteModal(false);
        setSelectedAdmission(null);
      }
    };

  // ============================================================
  // NAVIGATION
  // ============================================================

  const handleAddAdmission = () => {
    navigate('/add-admission');
  };

  const handleEdit = (
    admission
  ) => {
    navigate(
      `/edit-admission/${admission.id}`
    );
  };

   const handleView = (
    admission
  ) => {
    setSelectedAdmission(
      admission
    );

    setPdfAction('admission');
    setTempThemeColor(pdfThemeColor);
    setShowThemeColorModal(true);
  };

  const handleShowDeleteModal = (
    admission
  ) => {
    setSelectedAdmission(
      admission
    );

    setShowDeleteModal(true);
  };

  // ============================================================
  // FORM CHANGE
  // ============================================================

  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]:
        type === 'checkbox'
          ? checked
          : value,
    }));

    if (
      name ===
      'cancelAdmission'
    ) {
      setCancelAdmission(
        checked
      );
    }
  };

  // ============================================================
  // SAVE ADMISSION
  // ============================================================

  const handleSave = async () => {
    if (
      !formData.candidateName ||
      !formData.mobileNo ||
      !formData.gender ||
      !formData.email ||
      !formData.address ||
      !formData.status ||
      !formData.course
    ) {
      setSnackbarMessage(
        'Please fill all required fields'
      );

      setSnackbarSeverity('error');
      setOpenSnackbar(true);

      return;
    }

    try {
      const accessToken =
        localStorage.getItem(
          'accessToken'
        ) ||
        sessionStorage.getItem(
          'accessToken'
        );

      const response =
        await axios.post(
          `${API_BASE_URL}/api/admission/admissions/`,
          {
            admission_code:
              formData.admissionCode,

            admission_date:
              formData.admissionDate,

            candidate_name:
              formData.candidateName,

            mobile_no:
              formData.mobileNo,

            alternate_mobile_no:
              formData.alternateMobileNo,

            gender:
              formData.gender,

            email:
              formData.email,

            address:
              formData.address,

            status:
              formData.status,

            father_name:
              formData.fatherName,

            mother_name:
              formData.motherName,

            qualification:
              formData.qualification,

            aadhaar_no:
              formData.aadhaarNo,

            courses: [
              staticCourseData.find(
                (c) =>
                  c.name ===
                  formData.course
              )?.id || 1,
            ],

            send_email:
              formData.sendEmail,

            send_text_sms:
              formData.sendTestSMS,

            direct:
              formData.direct,

            cancel_admission:
              formData.cancelAdmission,

            cancellation_date:
              formData.cancelAdmission
                ? formData.cancellationDate
                : null,

            reason:
              formData.cancelAdmission
                ? formData.reason
                : null,
          },
          {
            headers: {
              Authorization:
                `Bearer ${accessToken}`,
            },
          }
        );

      if (
        response.status !== 201
      ) {
        throw new Error(
          'Failed to add admission'
        );
      }

      setSnackbarMessage(
        'Admission added successfully'
      );

      setSnackbarSeverity(
        'success'
      );

      setOpenSnackbar(true);

      const user =
        getStoredUser();

      fetchAdmissions(
        user?.organization_id ||
          organizationId ||
          null,
        selectedBranchId || null
      );

      setShowAddAdmissionModal(
        false
      );

      setShowSuccessModal(true);
    } catch (error) {
      console.error(
        'Add admission failed:',
        error
      );

      setSnackbarMessage(
        'Failed to add admission'
      );

      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  // ============================================================
  // UPDATE ADMISSION
  // ============================================================

  const handleUpdate = async () => {
    if (
      !formData.candidateName ||
      !formData.mobileNo ||
      !formData.gender ||
      !formData.email ||
      !formData.address ||
      !formData.status ||
      !formData.course
    ) {
      setSnackbarMessage(
        'Please fill all required fields'
      );

      setSnackbarSeverity('error');
      setOpenSnackbar(true);

      return;
    }

    const payload = {
      admission_code:
        formData.admissionCode,

      admission_date:
        formData.admissionDate,

      organization:
        formData.organization,

      branch:
        formData.branch,

      candidate_name:
        formData.candidateName,

      mobile_no:
        formData.mobileNo,

      alternate_mobile_no:
        formData.alternateMobileNo ||
        null,

      gender:
        formData.gender,

      email:
        formData.email,

      address:
        formData.address,

      status:
        formData.status,

      father_name:
        formData.fatherName ||
        null,

      mother_name:
        formData.motherName ||
        null,

      qualification:
        formData.qualification ||
        null,

      aadhaar_no:
        formData.aadhaarNo ||
        null,

      courses: [
        staticCourseData.find(
          (c) =>
            c.name ===
            formData.course
        )?.id,
      ],

      send_email:
        formData.sendEmail,

      send_text_sms:
        formData.sendTestSMS,

      direct:
        formData.direct,

      cancel_admission:
        formData.cancelAdmission,

      cancellation_date:
        formData.cancelAdmission
          ? formData.cancellationDate
          : null,

      reason:
        formData.cancelAdmission
          ? formData.reason
          : null,
    };

    try {
      const accessToken =
        localStorage.getItem(
          'accessToken'
        ) ||
        sessionStorage.getItem(
          'accessToken'
        );

      const response =
        await axios.put(
          `${API_BASE_URL}/api/admission/admissions/${selectedAdmission.id}/`,
          payload,
          {
            headers: {
              Authorization:
                `Bearer ${accessToken}`,
            },
          }
        );

      if (
        response.status !== 200
      ) {
        throw new Error(
          'Failed to update admission'
        );
      }

      setSnackbarMessage(
        'Admission updated successfully'
      );

      setSnackbarSeverity(
        'success'
      );

      setOpenSnackbar(true);

      const user =
        getStoredUser();

      fetchAdmissions(
        user?.organization_id ||
          organizationId ||
          null,
        selectedBranchId || null
      );

      setShowEditAdmissionModal(
        false
      );

      setShowSuccessModal(true);
    } catch (error) {
      console.error(
        'Update admission failed:',
        error
      );

      setSnackbarMessage(
        'Failed to update admission'
      );

      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  // ============================================================
  // ADMISSION PDF
  // ============================================================

     const generateAdmissionPDF =
    async (
      admission,
      themeColor = '#16355B',
      textColor = '#000000'
    ) => {
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 15;

      const hexToRgb = (hex) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return [r, g, b];
      };

      const branchIdForAdmission =
        admission.branch ||
        admission.branch_id ||
        selectedBranchId;

      const {
        orgName,
        branchName,
        logoUrl: branchLogoUrl,
      } = await fetchBranchDetails(branchIdForAdmission);

      const institutionName = orgName || 'INSTITUTION NAME';

      const themeRgb = hexToRgb(themeColor);
      const textRgb = hexToRgb(textColor);

      const cream = [244, 240, 229];
      const boxFill = [250, 248, 242];
      const darkText = [35, 35, 35];
      const softGray = [110, 110, 110];

      // ===================== PAGE BACKGROUND =====================
      doc.setFillColor(...cream);
      doc.rect(0, 0, pageWidth, pageHeight, 'F');

      // ===================== LOGO BADGE (top-left) =====================
      const logoRadius = 15;
      const logoCenterX = margin + logoRadius;
      const logoCenterY = margin + logoRadius;

      doc.setFillColor(255, 255, 255);
      doc.circle(logoCenterX, logoCenterY, logoRadius, 'F');

      if (branchLogoUrl) {
        try {
          const logoBase64 = await loadImageAsBase64(branchLogoUrl);

          doc.addImage(
            logoBase64,
            'PNG',
            logoCenterX - logoRadius + 2,
            logoCenterY - logoRadius + 2,
            (logoRadius - 2) * 2,
            (logoRadius - 2) * 2
          );
        } catch (err) {
          console.warn('Could not load branch logo:', err);
        }
      }

      doc.setDrawColor(...themeRgb);
      doc.setLineWidth(0.8);
      doc.circle(logoCenterX, logoCenterY, logoRadius, 'S');
      doc.setLineWidth(0.3);
      doc.circle(logoCenterX, logoCenterY, logoRadius - 1.5, 'S');

      // ===================== TITLE BLOCK =====================
      doc.setFont('times', 'bold');
      doc.setFontSize(22);
      doc.setTextColor(...darkText);
      doc.text(institutionName, pageWidth / 2, margin + 9, { align: 'center' });

      let headerY = margin + 9;

      if (branchName) {
        headerY += 8;
        doc.setFont('times', 'normal');
        doc.setFontSize(12);
        doc.setTextColor(...softGray);
        doc.text(`(${branchName})`, pageWidth / 2, headerY, { align: 'center' });
      }

      headerY += 10;
      doc.setFont('times', 'bolditalic');
      doc.setFontSize(15);
      doc.setTextColor(...darkText);
      doc.text(
        'STUDENT ADMISSION FORM'.split('').join(' '),
        pageWidth / 2,
        headerY,
        { align: 'center' }
      );

      headerY += 8;
      doc.setFont('times', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(...softGray);
      doc.text(
        `Session: ${new Date().getFullYear()}-${new Date().getFullYear() + 1}`,
        pageWidth / 2,
        headerY,
        { align: 'center' }
      );

      // ===================== ADM NO. =====================
      headerY += 10;

      const admCode = `${admissionPrefix}${
        admission.admission_code?.split(admissionPrefix)[1] ||
        admission.admission_code ||
        ''
      }`;

      doc.setFont('times', 'normal');
      doc.setFontSize(10);
      doc.setTextColor(...darkText);
      doc.text(`Adm. No: ${admCode}`, pageWidth - margin, headerY, {
        align: 'right',
      });

      // ===================== LAYOUT CONSTANTS =====================
      const contentY = headerY + 8;

      const photoW = 32;
      const photoH = 40;
      const photoX = pageWidth - margin - photoW;
      const photoY = contentY;

      const fieldsLeftEdge = margin;
      const fieldsRightEdge = photoX - 8;
      const fieldsW = fieldsRightEdge - fieldsLeftEdge;
      const labelW = 32;

      const rowH = 8;
      const rowSpacing = 11;

      // ===================== FIELD RENDERER =====================
      // Plain label on the left, a thin bordered box for the value.
      const drawField = (label, value, x, y, w, lw, options = {}) => {
        doc.setFont('times', 'normal');
        doc.setFontSize(9.5);
        doc.setTextColor(...darkText);
        doc.text(label, x, y);

        const boxX = x + lw;
        const boxW = w - lw;

        doc.setFillColor(...(options.badgeColor || boxFill));
        doc.roundedRect(boxX, y - 5.5, boxW, rowH, 1.2, 1.2, 'F');

        doc.setDrawColor(...(options.borderColor || themeRgb));
        doc.setLineWidth(0.25);
        doc.roundedRect(boxX, y - 5.5, boxW, rowH, 1.2, 1.2, 'S');

        doc.setFont('times', options.bold ? 'bold' : 'normal');
        doc.setFontSize(9.5);
        doc.setTextColor(...(options.textColor || textRgb));

        const safeVal = value ? String(value) : '';
        const maxPx = boxW - 4;

        const truncated =
          doc.getTextWidth(safeVal) * (9.5 / 10) > maxPx
            ? safeVal.substring(0, Math.floor(maxPx / 2.3)) + '…'
            : safeVal;

        if (truncated) {
          doc.text(truncated, boxX + 3, y);
        }
      };

      let fy = contentY + 6;

      // ROW 1: Admission Date | Status (green badge if "Admitted")
      const halfW = (fieldsW - 8) / 2;

      drawField(
        'Admission Date',
        admission.admission_date || '',
        fieldsLeftEdge,
        fy,
        halfW,
        labelW
      );

      const statusText = admission.status || '';
      const isAdmitted = statusText.toLowerCase().includes('admit');

      drawField(
        'Status',
        statusText,
        fieldsLeftEdge + halfW + 8,
        fy,
        halfW - 10,
        18,
        {
          badgeColor: isAdmitted ? [214, 240, 220] : boxFill,
          textColor: isAdmitted ? [30, 120, 65] : textRgb,
          borderColor: isAdmitted ? [30, 120, 65] : themeRgb,
          bold: true,
        }
      );

      fy += rowSpacing;

      // ROW 2: Candidate Name
      drawField(
        'Candidate Name',
        admission.candidate_name || '',
        fieldsLeftEdge,
        fy,
        fieldsW,
        labelW
      );
      fy += rowSpacing;

      // ROW 3: Email
      drawField('Email', admission.email || '', fieldsLeftEdge, fy, fieldsW, labelW);
      fy += rowSpacing;

      // ROW 4: Mobile No. / Alt. Mobile (combined on one row)
      doc.setFont('times', 'normal');
      doc.setFontSize(9.5);
      doc.setTextColor(...darkText);
      doc.text('Mobile No.', fieldsLeftEdge, fy);

      const mobBoxX = fieldsLeftEdge + labelW;
      const mobBoxW = 32;

      doc.setFillColor(...boxFill);
      doc.roundedRect(mobBoxX, fy - 5.5, mobBoxW, rowH, 1.2, 1.2, 'F');
      doc.setDrawColor(...themeRgb);
      doc.setLineWidth(0.25);
      doc.roundedRect(mobBoxX, fy - 5.5, mobBoxW, rowH, 1.2, 1.2, 'S');
      doc.setTextColor(...textRgb);
      doc.text(String(admission.mobile_no || ''), mobBoxX + 3, fy);

      const slashX = mobBoxX + mobBoxW + 4;
      doc.setTextColor(...softGray);
      doc.text('/', slashX, fy);

      const altLabelX = slashX + 4;
      doc.setTextColor(...darkText);
      doc.text('Alt. Mobile', altLabelX, fy);

      const altBoxX = altLabelX + 22;
      const altBoxW = fieldsRightEdge - altBoxX;

      doc.setFillColor(...boxFill);
      doc.roundedRect(altBoxX, fy - 5.5, altBoxW, rowH, 1.2, 1.2, 'F');
      doc.setDrawColor(...themeRgb);
      doc.roundedRect(altBoxX, fy - 5.5, altBoxW, rowH, 1.2, 1.2, 'S');
      doc.setTextColor(...textRgb);
      doc.text(
        String(admission.alternate_mobile_no || ''),
        altBoxX + 3,
        fy
      );

      fy += rowSpacing;

      // ROW 5: Course
      const courseStr =
        admission.courses?.map((c) => c.course_name).join(', ') || '';

      drawField('Course', courseStr, fieldsLeftEdge, fy, fieldsW, labelW);
      fy += rowSpacing;

      // ROW 6: Batch
      let allBatches = [];

      if (admission.courses?.length) {
        admission.courses.forEach((c) => {
          if (c.batches?.length) {
            c.batches.forEach((b) =>
              allBatches.push(b.batch_name || b.name || '')
            );
          }
        });
      }

      const batchStr = allBatches.join(', ') || '';

      drawField('Batch', batchStr, fieldsLeftEdge, fy, fieldsW, labelW);
      fy += rowSpacing;

      fy = Math.max(fy, photoY + photoH + 12);

      // ROW: Gender (plain checkbox squares with an X, not filled)
      doc.setFont('times', 'normal');
      doc.setFontSize(9.5);
      doc.setTextColor(...darkText);
      doc.text('Gender', fieldsLeftEdge, fy);

      const cbSize = 3.6;
      let cbX = fieldsLeftEdge + labelW;
      const genders = ['Male', 'Female', 'Other'];
      const admGender = (admission.gender || '').toLowerCase();

      genders.forEach((g) => {
        doc.setDrawColor(...darkText);
        doc.setLineWidth(0.3);
        doc.rect(cbX, fy - cbSize, cbSize, cbSize, 'S');

              if (admGender === g.toLowerCase()) {
          doc.setDrawColor(...themeRgb);
          doc.setLineWidth(0.5);
          // tick mark: short stroke down-right, then long stroke up-right
          doc.line(
            cbX + 0.3,
            fy - cbSize / 2,
            cbX + cbSize / 2.3,
            fy - 0.3
          );
          doc.line(
            cbX + cbSize / 2.3,
            fy - 0.3,
            cbX + cbSize,
            fy - cbSize + 0.2
          );
        }

        doc.setFont('times', 'normal');
        doc.setFontSize(9.5);
        doc.setTextColor(...darkText);
        doc.text(g, cbX + cbSize + 2, fy);

        cbX += 30;
      });

      fy += rowSpacing;

      // ROW: Address
      drawField('Address', admission.address || '', fieldsLeftEdge, fy, fieldsW, labelW);
      fy += rowSpacing;

      // ===================== DIVIDER =====================
      fy += 2;
      doc.setDrawColor(...darkText);
      doc.setLineWidth(0.4);
      doc.line(margin, fy, pageWidth - margin, fy);
      fy += 10;

      // ===================== PERSONAL DETAILS (full width, two columns) =====================
      const fullW = pageWidth - 2 * margin;
      const half2 = (fullW - 8) / 2;

      drawField(
        "Father's Name",
        admission.father_name || '',
        margin,
        fy,
        half2,
        labelW
      );

      drawField(
        "Mother's Name",
        admission.mother_name || '',
        margin + half2 + 8,
        fy,
        half2,
        labelW
      );

      fy += rowSpacing;

      drawField(
        'Qualification',
        admission.qualification || '',
        margin,
        fy,
        half2,
        labelW
      );

      drawField(
        'Aadhaar No.',
        admission.aadhaar_no || '',
        margin + half2 + 8,
        fy,
        half2,
        labelW
      );

      fy += rowSpacing + 25;

      // ===================== PHOTO (drawn last so it sits on top) =====================
      doc.setDrawColor(...darkText);
      doc.setLineWidth(1);
      doc.rect(photoX, photoY, photoW, photoH, 'S');

      const photoUrl = admission.image || admission.photo_url || null;
      let photoLoaded = false;

      if (photoUrl) {
        try {
          let fullPhotoUrl = photoUrl;

          if (fullPhotoUrl.startsWith('/media/') || fullPhotoUrl.startsWith('/')) {
            fullPhotoUrl = `${API_BASE_URL}${fullPhotoUrl}`;
          }

          const base64Image = await new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';

            img.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = img.width;
              canvas.height = img.height;

              const ctx = canvas.getContext('2d');
              ctx.drawImage(img, 0, 0);

              resolve(canvas.toDataURL('image/jpeg'));
            };

            img.onerror = reject;
            img.src = fullPhotoUrl;
          });

          doc.addImage(
            base64Image,
            'JPEG',
            photoX + 1,
            photoY + 1,
            photoW - 2,
            photoH - 2
          );

          photoLoaded = true;
        } catch (err) {
          console.warn('Could not load admission photo:', err);
        }
      }

      if (!photoLoaded) {
        doc.setFillColor(230, 228, 220);
        doc.rect(photoX + 1, photoY + 1, photoW - 2, photoH - 2, 'F');

        doc.setFont('times', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(...softGray);
        doc.text('Photo', photoX + photoW / 2, photoY + photoH / 2, {
          align: 'center',
        });
      }

      doc.setFont('times', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...darkText);
      doc.text('Candidate Photo', photoX + photoW / 2, photoY + photoH + 5, {
        align: 'center',
      });

      // ===================== SIGNATURE ROW (only two, no seal) =====================
      const sigY = pageHeight - 32;
      const sigLineW = 42;

      doc.setDrawColor(...darkText);
      doc.setLineWidth(0.3);

      const leftSigX = margin;
      doc.line(leftSigX, sigY, leftSigX + sigLineW, sigY);
      doc.setFont('times', 'normal');
      doc.setFontSize(9);
      doc.text('Student Signature', leftSigX, sigY + 5);

      const rightSigX = pageWidth - margin - sigLineW;
      doc.line(rightSigX, sigY, rightSigX + sigLineW, sigY);
      doc.text('Authorized Signatory', rightSigX, sigY + 5);

      // small decorative sparkle, bottom-right
      doc.setFontSize(14);
      doc.setTextColor(220, 216, 205);
      doc.text('✦', pageWidth - margin - 4, pageHeight - 16, { align: 'right' });

      // ===================== FOOTER =====================
      doc.setFont('times', 'normal');
      doc.setFontSize(8);
      doc.setTextColor(...softGray);

      doc.text(
        'Generated by Institution Management System',
        pageWidth / 2,
        pageHeight - 12,
        { align: 'center' }
      );

      const currentDate = new Date().toLocaleDateString();

      doc.text(
        `Generated on: ${currentDate}`,
        pageWidth / 2,
        pageHeight - 8,
        { align: 'center' }
      );

      doc.text(`— 1/1 —`, pageWidth / 2, pageHeight - 4, { align: 'center' });

      window.open(doc.output('bloburl'), '_blank');
    };

  // ============================================================
  // ID CARD
  // ============================================================

    const handleGenerateIDCard =
    async () => {
      try {

        const accessToken =
          localStorage.getItem(
            'accessToken'
          ) ||
          sessionStorage.getItem(
            'accessToken'
          );

        const response =
          await axios.get(
            `${API_BASE_URL}/api/admission/admissions/${selectedAdmission.id}/`,
            {
              headers: {
                Authorization:
                  `Bearer ${accessToken}`,
              },
            }
          );

        if (
          response.status !==
          200
        ) {
          throw new Error(
            'Failed to generate ID card'
          );
        }

        const admissionData =
          response.data;

        setIdCardData(
          admissionData
        );

                  const branchIdForIdCard =
          admissionData.branch ||
          admissionData.branch_id ||
          selectedBranchId;

                const {
          orgName: orgNameForCard,
          branchName: branchNameForCard,
          logoUrl: branchLogoUrlForCard,
        } = await fetchBranchDetails(
          branchIdForIdCard
        );

        let logoBase64 = null;

        if (branchLogoUrlForCard) {
          try {
            logoBase64 =
              await loadImageAsBase64(
                branchLogoUrlForCard
              );
          } catch (err) {
            console.warn(
              'Could not load branch logo for ID card:',
              err
            );
          }
        }

        const mappedData = {
          student_name:
            admissionData.candidate_name ||
            '',

          roll_number:
            admissionData.admission_code ||
            '',

          courses:
            admissionData.courses
              ?.map(
                (c) =>
                  c.course_name
              )
              .join(', ') ||
            '',

          admission_date:
            admissionData.admission_date ||
            '',

          emergency_contact:
            admissionData.mobile_no ||
            '',

          alternate_contact:
            admissionData.alternate_mobile_no ||
            '',

                                   school_name:
            orgNameForCard ||
            admissionData.organization_name ||
            admissionData.school_name ||
            'Main Branch',

          branch_name:
            branchNameForCard || '',

          address:
            admissionData.address ||
            '',

                   photo_url:
            admissionData.image ||
            null,

          logo_base64: logoBase64,
        };

               generateIDCardPDF(
          mappedData,
          tempThemeColor
        );

        setSnackbarMessage(
          'ID Card generated successfully'
        );

        setSnackbarSeverity(
          'success'
        );

        setOpenSnackbar(true);
      } catch (error) {
        console.error(
          'Error generating ID card:',
          error
        );

        const errorMsg =
          error?.response?.data?.message ||
          error?.message ||
          'Failed to generate ID card';

        setSnackbarMessage(
          errorMsg
        );

        setSnackbarSeverity(
          'error'
        );

        setOpenSnackbar(true);
      }
    };

  // ============================================================
  // ID CARD PDF
  // ============================================================

  const generateIDCardPDF = (
    data,
    themeColor = '#16355B'
  ) => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [90, 65],
    });

    const cardWidth = 90;
    const cardHeight = 65;

    const hexToRgb = (hex) => {
      const r = parseInt(
        hex.slice(1, 3),
        16
      );

      const g = parseInt(
        hex.slice(3, 5),
        16
      );

      const b = parseInt(
        hex.slice(5, 7),
        16
      );

      return [r, g, b];
    };

    const primaryColor =
      hexToRgb(themeColor);

    // HEADER
    doc.setFillColor(
      ...primaryColor
    );

    doc.rect(
      0,
      0,
      cardWidth,
      18,
      'F'
    );

    doc.setFont(
      'helvetica',
      'bold'
    );

    doc.setFontSize(12);

    doc.setTextColor(
      255,
      255,
      255
    );

        // Shift text right if a logo is present so it doesn't overlap
    const headerTextX = data.logo_base64 ? 20 : 6;

       doc.text(
      data.school_name ||
        'Main Branch',
      headerTextX,
      8
    );

    doc.setFont(
      'helvetica',
      'normal'
    );

    doc.setFontSize(6);

    doc.setTextColor(
      230,
      230,
      230
    );

    if (data.branch_name) {
      doc.text(
        `(${data.branch_name})`,
        headerTextX,
        13
      );
    }

    // BRANCH LOGO (top-left of header)
    if (data.logo_base64) {
      try {
        doc.addImage(
          data.logo_base64,
          'PNG',
          4,
          2,
          14,
          14
        );
      } catch (err) {
        console.warn(
          'Could not render branch logo on ID card:',
          err
        );
      }
    }

    doc.setFont(
      'helvetica',
      'bold'
    );

    doc.setFontSize(8);

    doc.setTextColor(
      255,
      255,
      255
    );

    

    // BACKGROUND
    doc.setFillColor(
      245,
      245,
      245
    );

    doc.rect(
      0,
      18,
      cardWidth,
      cardHeight - 18,
      'F'
    );

    // PHOTO
    const photoX =
      cardWidth - 26;

    const photoY = 20;

    const photoWidth = 22;
    const photoHeight = 28;

    doc.setFillColor(
      200,
      200,
      200
    );

    doc.rect(
      photoX + 0.5,
      photoY + 0.5,
      photoWidth,
      photoHeight,
      'F'
    );

    doc.setFillColor(
      255,
      255,
      255
    );

    doc.rect(
      photoX,
      photoY,
      photoWidth,
      photoHeight,
      'F'
    );

    doc.setDrawColor(
      180,
      180,
      180
    );

    doc.setLineWidth(
      0.3
    );

    doc.rect(
      photoX,
      photoY,
      photoWidth,
      photoHeight,
      'S'
    );

    if (data.photo_url) {
      try {
        let imageUrl =
          data.photo_url;

        if (
          imageUrl.startsWith(
            '/media/'
          )
        ) {
          imageUrl =
            `${API_BASE_URL}${imageUrl}`;
        }

        doc.addImage(
          imageUrl,
          'JPEG',
          photoX + 1,
          photoY + 1,
          photoWidth - 2,
          photoHeight - 2
        );
      } catch (e) {
        console.error(
          'Error loading image:',
          e
        );

        doc.setFillColor(
          240,
          240,
          240
        );

        doc.rect(
          photoX + 1,
          photoY + 1,
          photoWidth - 2,
          photoHeight - 2,
          'F'
        );

        doc.setFontSize(8);

        doc.setTextColor(
          150,
          150,
          150
        );

        doc.text(
          'PHOTO',
          photoX +
            photoWidth / 2,
          photoY +
            photoHeight / 2,
          {
            align: 'center',
          }
        );
      }
    } else {
      doc.setFillColor(
        240,
        240,
        240
      );

      doc.rect(
        photoX + 1,
        photoY + 1,
        photoWidth - 2,
        photoHeight - 2,
        'F'
      );

      doc.setFontSize(8);

      doc.setTextColor(
        150,
        150,
        150
      );

      doc.text(
        'PHOTO',
        photoX +
          photoWidth / 2,
        photoY +
          photoHeight / 2,
        {
          align: 'center',
        }
      );
    }

    // STUDENT DETAILS
    doc.setTextColor(
      64,
      64,
      64
    );

    doc.setFont(
      'helvetica',
      'normal'
    );

       let y = 22;

    const leftMargin = 6;

    const labelWidth = 20;

    const lineSpacing = 5;

    const addField = (
      label,
      value = '',
      yPos
    ) => {
      doc.setFont(
        'helvetica',
        'bold'
      );

      doc.setFontSize(6);

      doc.setTextColor(
        64,
        64,
        64
      );

      doc.text(
        label + ':',
        leftMargin,
        yPos
      );

      doc.setDrawColor(
        180,
        180,
        180
      );

      doc.setLineWidth(
        0.2
      );

      const underlineStart =
        leftMargin +
        labelWidth;

      const underlineEnd =
        photoX - 4;

      doc.line(
        underlineStart,
        yPos + 1,
        underlineEnd,
        yPos + 1
      );

      if (
        value &&
        value !== 'null' &&
        value !== 'undefined' &&
        value !== 'N/A'
      ) {
        doc.setFont(
          'helvetica',
          'normal'
        );

        doc.setFontSize(6);

        doc.setTextColor(
          0,
          0,
          0
        );

        const displayValue =
          value.toString();

        const maxChars = 25;

        const truncatedValue =
          displayValue.length >
          maxChars
            ? displayValue.substring(
                0,
                maxChars - 3
              ) + '...'
            : displayValue;

        doc.text(
          truncatedValue,
          underlineStart + 1,
          yPos
        );
      }

      return (
        yPos +
        lineSpacing
      );
    };

    const contactNumber = [
      data.emergency_contact,
      data.alternate_contact,
    ]
      .filter(
        (num) =>
          num &&
          num !== 'null' &&
          num !== 'undefined' &&
          num !== 'N/A'
      )
      .join(', ');

    y = addField(
      'Name',
      data.student_name,
      y
    );

    y = addField(
      'Roll No.',
      data.roll_number,
      y
    );

    y = addField(
      'Course',
      data.courses,
      y
    );

    y = addField(
      'Admission Date',
      data.admission_date,
      y
    );

       y = addField(
      'Contact',
      contactNumber ||
        'N/A',
      y
    );

    y = addField(
      'Address',
      data.address ||
        'N/A',
      y
    );

    // FOOTER

    // FOOTER
    const footerY =
      cardHeight - 8;

    doc.setFillColor(
      255,
      255,
      255
    );

    doc.rect(
      0,
      footerY - 2,
      cardWidth,
      10,
      'F'
    );

    doc.setDrawColor(
      ...primaryColor
    );

    doc.setLineWidth(
      0.3
    );

    doc.line(
      0,
      footerY - 2,
      cardWidth,
      footerY - 2
    );

    doc.setFont(
      'helvetica',
      'normal'
    );

    doc.setFontSize(5);

    doc.setTextColor(
      64,
      64,
      64
    );

    doc.text(
      'Student Signature',
      leftMargin,
      footerY + 2
    );

    doc.setDrawColor(
      150,
      150,
      150
    );

    doc.setLineWidth(
      0.2
    );

    doc.line(
      leftMargin + 15,
      footerY + 2,
      leftMargin + 30,
      footerY + 2
    );

    doc.text(
      'Authorized By',
      cardWidth - 30,
      footerY + 2
    );

    doc.line(
      cardWidth - 20,
      footerY + 2,
      cardWidth - 6,
      footerY + 2
    );

    // BORDER
    doc.setDrawColor(
      ...primaryColor
    );

    doc.setLineWidth(
      0.5
    );

    doc.rect(
      0,
      0,
      cardWidth,
      cardHeight,
      'S'
    );

    window.open(
      doc.output('bloburl'),
      '_blank'
    );
  };

  // ============================================================
  // PAGINATION
  // ============================================================

  const handleChangePage = (
    event,
    newPage
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage =
    (event) => {
      setRowsPerPage(
        parseInt(
          event.target.value,
          10
        )
      );

      setPage(1);
    };

  // ============================================================
  // IMPORT / EXPORT HELPERS
  // ============================================================

  const getAccessToken = () =>
    localStorage.getItem('accessToken') ||
    sessionStorage.getItem('accessToken');

  // Saves a file received from the API to the user's computer
  const downloadBlob = (data, fileName) => {
    const url = window.URL.createObjectURL(
      new Blob([data])
    );

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  };

  // ============================================================
  // DOWNLOAD TEMPLATE
  // ============================================================

  const handleDownloadTemplate = async () => {
    try {
      setDownloadingTemplate(true);

      const response = await axios.get(
        `${API_BASE_URL}/api/admission/admissions/template/`,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          responseType: 'blob',
        }
      );

      downloadBlob(
        response.data,
        'admission_import_template.xlsx'
      );

      setSnackbarMessage(
        'Template downloaded successfully'
      );
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } catch (error) {
      console.error(
        'Template download failed:',
        error
      );

      setSnackbarMessage(
        'Failed to download template'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setDownloadingTemplate(false);
    }
  };

  // ============================================================
  // IMPORT
  // ============================================================

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const isExcel = /\.(xlsx|xls)$/i.test(
      file.name
    );

    if (!isExcel) {
      setSnackbarMessage(
        'Please select an Excel file (.xlsx or .xls)'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    setImportFile(file);
  };

  const closeImportModal = () => {
    setShowImportModal(false);
    setImportFile(null);
  };

  const handleImport = async () => {
    if (!importFile) {
      setSnackbarMessage(
        'Please select a file to import'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
      return;
    }

    try {
      setImporting(true);

      const formDataToSend = new FormData();

      // NOTE: "file" is the field name the backend expects.
      // Confirm it with your backend developer.
      formDataToSend.append('file', importFile);

      // Do NOT set Content-Type manually. Axios adds it
      // automatically with the correct multipart boundary.
      const response = await axios.post(
        `${API_BASE_URL}/api/admission/admissions/import/`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
      );

      setSnackbarMessage(
        response.data?.message ||
          'Admissions imported successfully!'
      );
      setSnackbarSeverity('success');
      setOpenSnackbar(true);

      closeImportModal();

      // Refresh the table so imported rows appear
      const user = getStoredUser();

      fetchAdmissions(
        user?.organization_id ||
          organizationId ||
          null,
        selectedBranchId || null
      );
    } catch (error) {
      console.error('Import failed:', error);

      const data = error?.response?.data;

      setSnackbarMessage(
        data?.message ||
          data?.error ||
          data?.detail ||
          'Failed to import admissions'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setImporting(false);
    }
  };

  // ============================================================
  // EXPORT
  // ============================================================

  const handleExport = async () => {
    try {
      setExporting(true);

      const user = getStoredUser();

      const orgId =
        user?.organization_id ||
        organizationId ||
        null;

      const params = {};

      if (orgId) params.organization_id = orgId;

      if (selectedBranchId) {
        params.branch_id = selectedBranchId;
      }

      /*
       * By default the API exports active + inactive.
       * So we only send a param when "Active only" is chosen.
       */
      if (exportType === 'active') {
        params.include_inactive = false;
      }

      const response = await axios.get(
        `${API_BASE_URL}/api/admission/admissions/export/excel/`,
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          params,
          responseType: 'blob',
        }
      );

      downloadBlob(
        response.data,
        exportType === 'active'
          ? 'active_students.xlsx'
          : 'all_students.xlsx'
      );

      setSnackbarMessage(
        'Export completed successfully'
      );
      setSnackbarSeverity('success');
      setOpenSnackbar(true);

      setShowExportModal(false);
    } catch (error) {
      console.error('Export failed:', error);

      setSnackbarMessage(
        'Failed to export students'
      );
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setExporting(false);
    }
  };

  // ============================================================
  // CANCEL
  // ============================================================

  const handleCancel = () => {
    setShowEditAdmissionModal(
      false
    );

    setShowViewAdmissionModal(
      false
    );

    setFormData({
      sendEmail: false,
      sendTestSMS: false,
      direct: false,
      cancelAdmission: false,
      cancellationDate: '',
      reason: '',
      corporate: false,
      admissionCode: '',
      admissionDate: new Date()
        .toISOString()
        .split('T')[0],
      candidateName: '',
      mobileNo: '',
      alternateMobileNo: '',
      gender: '',
      email: '',
      address: '',
      status: '',
      fatherName: '',
      motherName: '',
      qualification: '',
      aadhaarNo: '',
      course: '',
      batches: '',
    });

    setCancelAdmission(
      false
    );
  };

  // ============================================================
  // PAGINATED DATA
  // ============================================================

  const paginatedData =
    filteredData.slice(
      (page - 1) *
        rowsPerPage,
      page * rowsPerPage
    );

  // ============================================================
  // RETURN
  // ============================================================

  return (
    <Container
      disableGutters
      sx={{
        width: '100%',
        maxWidth:
          'none !important',
      }}
    >
      {/* ======================================================
          TOP BAR
      ====================================================== */}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:
            'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
          gap: 2,
        }}
      >
        {/* <BackButton /> */}

        <Box
          sx={{
            gap: 2,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems:
              'center',
          }}
        >
          {/* SEARCH */}

          <TextField
            variant="outlined"
            placeholder="Search by Candidate Name"
            value={searchQuery}
            onChange={(e) =>
              setSearchQuery(
                e.target.value
              )
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color:
                        theme.palette
                          .primary
                          .main,
                      marginLeft: 1.5,
                      fontSize: 22,
                    }}
                  />
                </InputAdornment>
              ),

              endAdornment:
                searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() =>
                        setSearchQuery(
                          ''
                        )
                      }
                      sx={{
                        color: 'grey',
                        marginRight: 1,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),

              sx: {
                borderRadius:
                  '30px',

                backgroundColor:
                  theme.palette
                    .mode ===
                  'dark'
                    ? 'rgba(255,255,255,0.15)'
                    : 'rgba(255,255,255,1)',

                boxShadow:
                  theme.palette
                    .mode ===
                  'dark'
                    ? '0 2px 8px rgba(0,0,0,0.3)'
                    : '0 2px 8px rgba(0,0,0,0.1)',

                '& .MuiOutlinedInput-notchedOutline':
                  {
                    border:
                      `1px solid ${
                        theme
                          .palette
                          .mode ===
                        'dark'
                          ? 'rgba(255,255,255,0.2)'
                          : 'rgba(0,0,0,0.1)'
                      }`,
                  },

                '&:hover': {
                  backgroundColor:
                    theme
                      .palette
                      .mode ===
                    'dark'
                      ? 'rgba(255,255,255,0.2)'
                      : 'rgba(245,245,245,1)',

                  boxShadow:
                    theme
                      .palette
                      .mode ===
                    'dark'
                      ? '0 2px 12px rgba(0,0,0,0.4)'
                      : '0 2px 12px rgba(0,0,0,0.15)',
                },

                '&.Mui-focused':
                  {
                    backgroundColor:
                      theme
                        .palette
                        .mode ===
                      'dark'
                        ? 'rgba(255,255,255,0.25)'
                        : 'rgba(255,255,255,1)',

                    boxShadow:
                      `0 0 0 3px ${theme.palette.primary.main}20`,

                    '& .MuiOutlinedInput-notchedOutline':
                      {
                        border:
                          `2px solid ${theme.palette.primary.main}`,
                      },
                  },

                paddingLeft: 1.5,
                height: '50px',
                transition:
                  'all 0.3s ease',
              },
            }}
            sx={{
              width: 300,
              maxWidth: '100%',
              '& .MuiInputBase-input':
                {
                  padding:
                    '10px 14px',
                  color:
                    theme.palette
                      .text
                      .primary,
                  fontWeight: 500,
                },
            }}
          />


          {/* ADD */}

          <Button
            variant="contained"
            onClick={
              handleAddAdmission
            }
            sx={{
              width: '180px',
              borderRadius:
                '10px',
              height: '50px',
              padding:
                '10px 0',
              fontWeight:
                'bold',
              backgroundColor:
                theme.palette
                  .primary
                  .main,

              '&:hover': {
                backgroundColor:
                  theme.palette
                    .primary
                    .dark,
              },
            }}
            startIcon={
              <AddIcon />
            }
          >
            ADD ADMISSION
          </Button>

                   {/* IMPORT ICON */}

          <Tooltip
            title="Import Admissions"
            arrow
            placement="top"
          >
            <IconButton
              onClick={() =>
                setShowImportModal(true)
              }
              sx={{
                width: 50,
                height: 50,
                backgroundColor:
                  theme.palette.warning.main,
                color: '#fff',
                '&:hover': {
                  backgroundColor:
                    theme.palette.warning.dark,
                },
              }}
            >
              <FileUploadIcon />
            </IconButton>
          </Tooltip>

          {/* EXPORT ICON */}

          <Tooltip
            title="Export Admissions"
            arrow
            placement="top"
          >
            <IconButton
              onClick={() =>
                setShowExportModal(true)
              }
              sx={{
                width: 50,
                height: 50,
                backgroundColor:
                  theme.palette.info.main,
                color: '#fff',
                '&:hover': {
                  backgroundColor:
                    theme.palette.info.dark,
                },
              }}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>

          {/* BULK ID */}

          <Button
            variant="contained"
            color="success"
            onClick={() =>
              navigate(
                '/bulk-id-card'
              )
            }
            sx={{
              width: '160px',
              borderRadius:
                '10px',
              height: '50px',
              padding:
                '10px 0',
              fontWeight:
                'bold',
            }}
          >
            Generate Bulk ID
          </Button>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems:
              'center',
          }}
        >
          <IconButton
            onClick={() =>
              setShowUserGuideModal(
                true
              )
            }
            sx={{
              width: 60,
              height: 60,
              borderRadius:
                '50%',
              minWidth: 0,
            }}
          >
            <InfoOutlineIcon
              sx={{
                fontSize: 30,
              }}
            />
          </IconButton>
        </Box>
      </Box>

      {/* ======================================================
          TABLE
      ====================================================== */}

      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          width: '100%',
          boxSizing:
            'border-box',
          mx: 'auto',
          backgroundColor:
            theme.palette
              .background
              .paper,
          borderRadius:
            '16px',
        }}
      >
        <CustomTableScrollbar
          sx={{
            width: '100%',
            overflowX: 'auto',
          }}
        >
          <TableContainer
            sx={{
              width: '100%',
              borderRadius:
                '16px',
              overflowX:
                'auto',
            }}
          >
            <Table
              sx={{
                minWidth:
                  '1400px',
                width: '100%',
                tableLayout:
                  'fixed',

                '& .MuiTableHead-root .MuiTableCell-root':
                  {
                    fontWeight:
                      'bold',
                    backgroundColor:
                      theme
                        .palette
                        .primary
                        .main,
                    color: 'white',
                  },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      fontSize: '1.1rem',
                      width: '6%',
                    }}
                  >
                    S.No
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '12%',
                    }}
                  >
                    Admission No.
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '15%',
                    }}
                  >
                    Candidate Name
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '12%',
                    }}
                  >
                    Admission Date
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '18%',
                    }}
                  >
                    Email
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '12%',
                    }}
                  >
                    Mobile No.
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '12%',
                    }}
                  >
                    Course
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight:
                        'bold',
                      fontSize:
                        '1.1rem',
                      width: '10%',
                    }}
                  >
                    Batches
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight:
                        'bold',
                      backgroundColor:
                        theme
                          .palette
                          .primary
                          .dark,
                      fontSize:
                        '1.1rem',
                      width: '8%',
                    }}
                  >
                    ID Card
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight:
                        'bold',
                      backgroundColor:
                        theme
                          .palette
                          .primary
                          .dark,
                      fontSize:
                        '1.1rem',
                      width: '8%',
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData.length >
                0 ? (
                  paginatedData.map(
                    (
                      admission,
                      index
                    ) => {
                      const courseNames =
                        admission.courses &&
                        admission
                          .courses
                          .length >
                          0
                          ? admission.courses
                              .map(
                                (c) =>
                                  c.course_name ||
                                  c.course ||
                                  `Course ${c.course_id}`
                              )
                              .join(
                                ', '
                              )
                          : '—';

                      let allBatches =
                        [];

                      if (
                        admission.courses &&
                        admission
                          .courses
                          .length >
                          0
                      ) {
                        admission.courses.forEach(
                          (course) => {
                            if (
                              course.batches &&
                              course
                                .batches
                                .length >
                                0
                            ) {
                              course.batches.forEach(
                                (
                                  batch
                                ) => {
                                  allBatches.push(
                                    batch.batch_name ||
                                      batch.name ||
                                      `Batch ${batch.batch_id}`
                                  );
                                }
                              );
                            }
                          }
                        );
                      }

                      const batchNames =
                        allBatches.length >
                        0
                          ? allBatches.join(
                              ', '
                            )
                          : '—';

                      return (
                        <TableRow
                          key={
                            admission.id
                          }
                          sx={{
                            backgroundColor:
                              index %
                                2 ===
                              0
                                ? theme
                                    .palette
                                    .background
                                    .paper
                                : theme
                                    .palette
                                    .action
                                    .hover,

                            '&:hover':
                              {
                                backgroundColor:
                                  'rgba(0,0,0,0.04)',
                              },
                          }}
                        >
                          <TableCell>
                            {(page - 1) * rowsPerPage + index + 1}
                          </TableCell>
                          <Tooltip
                            title={
                              admission.admission_code ||
                              '—'
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '150px',
                              }}
                            >
                              {admission.admission_code ||
                                '—'}
                            </TableCell>
                          </Tooltip>

                                                   <Tooltip
                            title={
                              admission.candidate_name ||
                              '—'
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              onClick={() =>
                                navigate(
                                  `/view-student/${admission.id}`
                                )
                              }
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '150px',
                                cursor:
                                  'pointer',
                                color:
                                  'primary.main',
                                fontWeight: 500,
                                '&:hover': {
                                  textDecoration:
                                    'underline',
                                },
                              }}
                            >
                              {admission.candidate_name ||
                                '—'}
                            </TableCell>
                          </Tooltip>

                          <Tooltip
                            title={
                              admission.admission_date ||
                              '—'
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '120px',
                              }}
                            >
                              {admission.admission_date ||
                                '—'}
                            </TableCell>
                          </Tooltip>

                          <Tooltip
                            title={
                              admission.email ||
                              '—'
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '200px',
                              }}
                            >
                              {admission.email ||
                                '—'}
                            </TableCell>
                          </Tooltip>

                          <Tooltip
                            title={
                              admission.mobile_no ||
                              '—'
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '120px',
                              }}
                            >
                              {admission.mobile_no ||
                                '—'}
                            </TableCell>
                          </Tooltip>

                          <Tooltip
                            title={
                              courseNames
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '200px',
                              }}
                            >
                              {
                                courseNames
                              }
                            </TableCell>
                          </Tooltip>

                          <Tooltip
                            title={
                              batchNames
                            }
                            arrow
                            placement="top"
                          >
                            <TableCell
                              sx={{
                                fontSize:
                                  '1rem',
                                overflow:
                                  'hidden',
                                textOverflow:
                                  'ellipsis',
                                whiteSpace:
                                  'nowrap',
                                maxWidth:
                                  '200px',
                              }}
                            >
                              {
                                batchNames
                              }
                            </TableCell>
                          </Tooltip>

                          {/* ID CARD */}

                          <TableCell
                            align="center"
                            sx={{
                              width:
                                '8%',
                            }}
                          >
                            <Tooltip
                              title="Generate ID Card"
                              arrow
                              placement="top"
                            >
                                                            <IconButton
                                onClick={() => {
                                  setSelectedAdmission(
                                    admission
                                  );

                                  setPdfAction('idcard');
                                  setTempThemeColor(pdfThemeColor);
                                  setShowThemeColorModal(true);
                                }}
                                sx={{
                                  color:
                                    theme
                                      .palette
                                      .primary
                                      .main,

                                  width:
                                    '20px',

                                  height:
                                    '20px',

                                  '&:hover':
                                    {
                                      backgroundColor:
                                        'rgba(0,0,0,0.04)',
                                    },
                                }}
                              >
                                <BadgeIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>

                          {/* ACTION */}

                          <TableCell
                            align="center"
                            sx={{
                              display:
                                'flex',
                              justifyContent:
                                'center',
                              alignItems:
                                'center',
                              gap: 0.5,
                            }}
                          >
                            <Tooltip
                              title="Print Admission PDF"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                onClick={() =>
                                  handleView(
                                    admission
                                  )
                                }
                                sx={{
                                  color:
                                    theme
                                      .palette
                                      .primary
                                      .light,

                                  p: 0.5,

                                  '&:hover':
                                    {
                                      backgroundColor:
                                        'rgba(0,0,0,0.04)',
                                    },
                                }}
                              >
                                <PrintIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Edit Admission"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                onClick={() =>
                                  handleEdit(
                                    admission
                                  )
                                }
                                sx={{
                                  color:
                                    theme
                                      .palette
                                      .warning
                                      .main,

                                  p: 0.5,

                                  '&:hover':
                                    {
                                      backgroundColor:
                                        'rgba(0,0,0,0.04)',
                                    },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Delete Admission"
                              arrow
                              placement="top"
                            >
                              <IconButton
                                color="error"
                                onClick={() =>
                                  handleShowDeleteModal(
                                    admission
                                  )
                                }
                                sx={{
                                  p: 0.5,

                                  '&:hover':
                                    {
                                      backgroundColor:
                                        'rgba(0,0,0,0.04)',
                                    },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={10}
                      align="center"
                      sx={{
                        fontSize:
                          '1rem',
                        py: 4,
                      }}
                    >
                      No admissions found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {/* ======================================================
          PAGINATION
      ====================================================== */}

      {filteredData.length >
        0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent:
              'space-between',
            alignItems:
              'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={
              theme.palette
                .primary
                .main
            }
          >
            Page{' '}
            <strong>
              {page}
            </strong>{' '}
            of{' '}
            <strong>
              {Math.ceil(
                filteredData.length /
                  rowsPerPage
              )}
            </strong>
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <IconButton
              onClick={() =>
                handleChangePage(
                  null,
                  page - 1
                )
              }
              disabled={
                page === 1
              }
              sx={{
                color:
                  theme.palette
                    .primary
                    .main,

                '&:hover': {
                  backgroundColor:
                    theme.palette
                      .action
                      .hover,
                },

                '&.Mui-disabled':
                  {
                    opacity:
                      0.3,
                  },

                borderRadius:
                  '50%',

                width: '36px',

                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>

            {[
              ...Array(
                Math.ceil(
                  filteredData.length /
                    rowsPerPage
                )
              ),
            ].map(
              (
                _,
                index
              ) => (
                <IconButton
                  key={
                    index + 1
                  }
                  onClick={() =>
                    handleChangePage(
                      null,
                      index + 1
                    )
                  }
                  sx={{
                    width:
                      '36px',
                    height:
                      '36px',
                    borderRadius:
                      '50%',

                    backgroundColor:
                      page ===
                      index + 1
                        ? theme
                            .palette
                            .primary
                            .main
                        : 'transparent',

                    color:
                      page ===
                      index + 1
                        ? theme
                            .palette
                            .primary
                            .contrastText
                        : theme
                            .palette
                            .text
                            .primary,

                    '&:hover':
                      {
                        backgroundColor:
                          page ===
                          index + 1
                            ? theme
                                .palette
                                .primary
                                .dark
                            : theme
                                .palette
                                .action
                                .hover,
                      },
                  }}
                >
                  {
                    index +
                    1
                  }
                </IconButton>
              )
            )}

            <IconButton
              onClick={() =>
                handleChangePage(
                  null,
                  page + 1
                )
              }
              disabled={
                page >=
                Math.ceil(
                  filteredData.length /
                    rowsPerPage
                )
              }
              sx={{
                color:
                  theme.palette
                    .primary
                    .main,

                '&:hover': {
                  backgroundColor:
                    theme.palette
                      .action
                      .hover,
                },

                '&.Mui-disabled':
                  {
                    opacity:
                      0.3,
                  },

                borderRadius:
                  '50%',

                width: '36px',

                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>

            <FormControl
              size="small"
              sx={{
                minWidth: 100,
                ml: 1,
              }}
            >
              <InputLabel
                id="rows-per-page-label"
                sx={{
                  color:
                    theme.palette
                      .text
                      .primary,
                }}
              >
                Rows
              </InputLabel>

              <Select
                labelId="rows-per-page-label"
                value={
                  rowsPerPage
                }
                onChange={
                  handleChangeRowsPerPage
                }
                label="Rows"
                sx={{
                  height:
                    '36px',

                  color:
                    theme.palette
                      .text
                      .primary,

                  '& .MuiOutlinedInput-notchedOutline':
                    {
                      borderColor:
                        theme
                          .palette
                          .text
                          .primary,
                    },

                  '&:hover .MuiOutlinedInput-notchedOutline':
                    {
                      borderColor:
                        theme
                          .palette
                          .primary
                          .main,
                    },
                }}
              >
                {rowsPerPageOptions.map(
                  (option) => (
                    <MenuItem
                      key={
                        option
                      }
                      value={
                        option
                      }
                    >
                      {option}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      {/* ======================================================
          SNACKBAR
      ====================================================== */}

      <Snackbar
        open={
          openSnackbar
        }
        autoHideDuration={
          4000
        }
        onClose={() =>
          setOpenSnackbar(
            false
          )
        }
        anchorOrigin={{
          vertical: 'top',
          horizontal:
            'center',
        }}
      >
        <Alert
          onClose={() =>
            setOpenSnackbar(
              false
            )
          }
          severity={
            snackbarSeverity
          }
          sx={{
            width: '100%',
          }}
        >
          {
            snackbarMessage
          }
        </Alert>
      </Snackbar>

      {/* ======================================================
          DELETE MODAL
      ====================================================== */}

      <Modal
        open={
          showDeleteModal
        }
        onClose={() =>
          setShowDeleteModal(
            false
          )
        }
        BackdropProps={{
          style: {
            backgroundColor:
              'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position:
              'absolute',
            top: '50%',
            left: '50%',
            transform:
              'translate(-50%, -50%)',
            width: 400,
            bgcolor:
              'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow:
              'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor:
                theme
                  .palette
                  .primary
                  .main,
              padding:
                '12px 16px',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
              }}
            >
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          <Box
            sx={{
              padding:
                '20px',
            }}
          >
            <Typography
              sx={{
                mb: 2,
              }}
            >
              Are you sure you
              want to delete{' '}
              <strong>
                {
                  selectedAdmission?.candidate_name
                }
              </strong>{' '}
              admission?
            </Typography>

            <Box
              sx={{
                display:
                  'flex',
                justifyContent:
                  'flex-end',
                mt: 3,
              }}
            >
              <Button
                onClick={() =>
                  setShowDeleteModal(
                    false
                  )
                }
                variant="outlined"
                sx={{
                  mr: 1,
                }}
               data-app-cancel="true">
                Cancel
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={() =>
                  handleDeleteAdmission(
                    selectedAdmission.id
                  )
                }
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

           {/* ======================================================
          IMPORT MODAL
      ====================================================== */}

      <Modal
        open={showImportModal}
        onClose={closeImportModal}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 480,
            maxWidth: '90vw',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: '#fff', fontWeight: 'bold' }}
            >
              Import Admissions
            </Typography>

            <IconButton
              onClick={closeImportModal}
              sx={{ color: '#fff' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* BODY */}
          <Box sx={{ padding: '20px' }}>
            {/* STEP 1 */}
            <Typography
              sx={{ fontWeight: 'bold', mb: 1 }}
            >
              Step 1: Download the template
            </Typography>

            <Button
              variant="outlined"
              startIcon={
                downloadingTemplate ? (
                  <CircularProgress size={18} />
                ) : (
                  <DownloadIcon />
                )
              }
              onClick={handleDownloadTemplate}
              disabled={downloadingTemplate}
              sx={{ mb: 3 }}
            >
              Download Template
            </Button>

            {/* STEP 2 */}
            <Typography
              sx={{ fontWeight: 'bold', mb: 0.5 }}
            >
              Step 2: Enter data in the proper format
            </Typography>

            <Typography
              variant="body2"
              sx={{ mb: 3 }}
            >
              Fill in the student details in the
              downloaded Excel file. Do not change the
              column headings.
            </Typography>

            {/* STEP 3 */}
            <Typography
              sx={{ fontWeight: 'bold', mb: 1 }}
            >
              Step 3: Choose the Excel file
            </Typography>

            <Button
              variant="contained"
              component="label"
              sx={{ mb: 1 }}
            >
              Select File

              <input
                type="file"
                hidden
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                onClick={(e) => {
                  // allows selecting the same file again
                  e.target.value = null;
                }}
              />
            </Button>

            {importFile && (
              <Typography
                variant="body2"
                sx={{ mb: 1 }}
              >
                Selected: {importFile.name}
              </Typography>
            )}

            {/* STEP 4 */}
            <Typography
              sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}
            >
              Step 4: Click Import
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
                mt: 2,
              }}
            >
              <Button
                variant="outlined"
                color="error"
                onClick={closeImportModal}
                disabled={importing}
               data-app-cancel="true">
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleImport}
                disabled={!importFile || importing}
                startIcon={
                  importing ? (
                    <CircularProgress
                      size={18}
                      color="inherit"
                    />
                  ) : null
                }
              >
                {importing ? 'Importing...' : 'Import'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ======================================================
          EXPORT MODAL
      ====================================================== */}

      <Modal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            maxWidth: '90vw',
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* HEADER */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: '#fff', fontWeight: 'bold' }}
            >
              Export Admissions
            </Typography>

            <IconButton
              onClick={() => setShowExportModal(false)}
              sx={{ color: '#fff' }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* BODY */}
          <Box sx={{ padding: '20px' }}>
            <Typography sx={{ mb: 1, fontWeight: 'bold' }}>
              Which students do you want to export?
            </Typography>

            <RadioGroup
              value={exportType}
              onChange={(e) =>
                setExportType(e.target.value)
              }
            >
              <FormControlLabel
                value="active"
                control={<Radio />}
                label="Active students only"
              />

              <FormControlLabel
                value="all"
                control={<Radio />}
                label="All students (active + inactive)"
              />
            </RadioGroup>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
                mt: 3,
              }}
            >
              <Button
                variant="outlined"
                color="error"
                onClick={() => setShowExportModal(false)}
                disabled={exporting}
               data-app-cancel="true">
                Cancel
              </Button>

              <Button
                variant="contained"
                onClick={handleExport}
                disabled={exporting}
                startIcon={
                  exporting ? (
                    <CircularProgress
                      size={18}
                      color="inherit"
                    />
                  ) : (
                    <FileDownloadIcon />
                  )
                }
              >
                {exporting ? 'Exporting...' : 'Export'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ======================================================
          SUCCESS MODAL
      ====================================================== */}

      <Modal
        open={
          showSuccessModal
        }
        onClose={() =>
          setShowSuccessModal(
            false
          )
        }
        BackdropProps={{
          style: {
            backgroundColor:
              'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position:
              'absolute',
            top: '50%',
            left: '50%',
            transform:
              'translate(-50%, -50%)',
            width: 400,
            bgcolor:
              'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow:
              'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor:
                theme
                  .palette
                  .primary
                  .main,
              padding:
                '12px 16px',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#fff',
              }}
            >
              {showAddAdmissionModal
                ? 'Admission Added ✅'
                : 'Admission Updated ✅'}
            </Typography>
          </Box>

          <Box
            sx={{
              padding:
                '20px',
            }}
          >
            <Typography
              sx={{
                mb: 2,
              }}
            >
              {showAddAdmissionModal
                ? 'Admission Added Successfully'
                : 'Admission Updated Successfully'}
            </Typography>

            <Box
              sx={{
                display:
                  'flex',
                justifyContent:
                  'flex-end',
                mt: 3,
              }}
            >
              <Button
                onClick={() =>
                  setShowSuccessModal(
                    false
                  )
                }
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* ======================================================
          USER GUIDE
      ====================================================== */}

      <Modal
        open={
          showUserGuideModal
        }
        onClose={() =>
          setShowUserGuideModal(
            false
          )
        }
        BackdropProps={{
          style: {
            backgroundColor:
              'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position:
              'absolute',
            top: '50%',
            left: '50%',
            transform:
              'translate(-50%, -50%)',
            width: 800,
            bgcolor:
              'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow:
              'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor:
                theme
                  .palette
                  .primary
                  .main,
              padding:
                '12px 16px',
              display:
                'flex',
              justifyContent:
                'flex-start',
              alignItems:
                'center',
              cursor:
                'pointer',
              position:
                'relative',
            }}
          >
            <Typography
              variant="h4"
              sx={{
                color: '#fff',
                fontWeight:
                  'bold',
              }}
            >
              Admission Module -
              User Guide
            </Typography>

            <IconButton
              onClick={() =>
                setShowUserGuideModal(
                  false
                )
              }
              sx={{
                color: '#fff',
                position:
                  'absolute',
                right: 14,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <CustomVerticalScrollbar
            sx={{
              maxHeight:
                '70vh',
              overflowY:
                'auto',
              padding:
                '20px',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight:
                  'bold',
                color:
                  theme.palette
                    .primary
                    .main,
                mb: 1,
              }}
            >
              ➤ Follow these
              steps to add a
              new admission:
            </Typography>

            <ul
              style={{
                marginLeft:
                  '20px',
                lineHeight:
                  '1.8',
                cursor:
                  'pointer',
              }}
            >
              <li>
                Click the{' '}
                <strong>
                  Add Admission
                </strong>{' '}
                button to open
                the admission
                form.
              </li>

              <li>
                Fill in all
                required student
                details: name,
                class, contact
                number, and
                address.
              </li>

              <li>
                Upload necessary
                documents: ID
                proof, previous
                marksheets, and
                photographs.
              </li>

              <li>
                Review all
                entered
                information for
                accuracy.
              </li>

              <li>
                Click{' '}
                <strong>
                  Submit
                </strong>{' '}
                to save the
                admission
                details.
              </li>

              <li>
                The student
                record will
                appear in the
                Admission List.
              </li>

              <li>
                Use the search
                bar or filters
                to quickly find
                student records.
              </li>
            </ul>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color:
                  theme.palette
                    .text
                    .primary,
              }}
            >
              ⚠️ Note: Ensure
              all mandatory
              fields are filled
              to avoid submission
              errors.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight:
                  'bold',
                color:
                  theme.palette
                    .primary
                    .main,
                mt: 3,
                mb: 1,
              }}
            >
              ➤ Follow these
              steps to edit an
              admission:
            </Typography>

            <ul
              style={{
                marginLeft:
                  '20px',
                lineHeight:
                  '1.8',
              }}
            >
              <li>
                Go to the{' '}
                <strong>
                  Admission Page
                </strong>
                .
              </li>

              <li>
                Find the student
                you want to
                update.
              </li>

              <li>
                Click the{' '}
                <strong>
                  Edit
                </strong>{' '}
                pencil icon
                beside the
                student's name.
              </li>

              <li>
                Update the
                necessary
                information in
                the form.
              </li>

              <li>
                Click{' '}
                <strong>
                  Update
                </strong>{' '}
                to save changes.
              </li>

              <li>
                Double-check all
                updates before
                saving.
              </li>
            </ul>

            <Typography
              variant="body2"
              sx={{
                mt: 2,
                color:
                  theme.palette
                    .text
                    .primary,
              }}
            >
              ⚠️ Note: Verify
              all mandatory
              fields before
              submitting to
              avoid errors.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight:
                  'bold',
                color:
                  theme.palette
                    .primary
                    .main,
                mt: 3,
                mb: 1,
              }}
            >
              ➤ Follow these
              steps to generate
              an admission PDF:
            </Typography>

            <ul
              style={{
                marginLeft:
                  '20px',
                lineHeight:
                  '1.8',
              }}
            >
              <li>
                Go to the{' '}
                <strong>
                  Admission Table
                </strong>
                .
              </li>

              <li>
                In the Action
                column, click the{' '}
                <strong>
                  PrintIcon
                </strong>{' '}
                button.
              </li>

              <li>
                Select the
                student for whom
                you want to
                generate the PDF.
              </li>

              <li>
                Choose a theme
                color for the
                PDF.
              </li>

              <li>
                Click{' '}
                <strong>
                  Generate PDF
                </strong>
                .
              </li>

              <li>
                The PDF will
                generate and
                download
                automatically.
              </li>
            </ul>

            <Typography
              variant="body1"
              sx={{
                fontWeight:
                  'bold',
                color:
                  theme.palette
                    .primary
                    .main,
                mt: 3,
                mb: 1,
              }}
            >
              ➤ Follow these
              steps to generate
              bulk ID cards:
            </Typography>

            <ul
              style={{
                marginLeft:
                  '20px',
                lineHeight:
                  '1.8',
              }}
            >
              <li>
                Go to the{' '}
                <strong>
                  Admission Page
                </strong>
                .
              </li>

              <li>
                Click the{' '}
                <strong>
                  Generate Bulk ID
                  Cards
                </strong>{' '}
                button at the top
                left.
              </li>

              <li>
                Select the
                Session, Course,
                and Batch from
                the dropdowns.
              </li>

              <li>
                Click{' '}
                <strong>
                  Generate Bulk ID
                  Cards
                </strong>
                .
              </li>

              <li>
                The ID cards will
                generate and
                download
                automatically.
              </li>
            </ul>

            <Typography
              variant="body1"
              sx={{
                fontWeight:
                  'bold',
                color:
                  theme.palette
                    .primary
                    .main,
                mt: 3,
                mb: 1,
              }}
            >
              ➤ Follow these
              steps to generate
              ID cards:
            </Typography>

            <ul
              style={{
                marginLeft:
                  '20px',
                lineHeight:
                  '1.8',
              }}
            >
              <li>
                Go to the{' '}
                <strong>
                  Admission Table
                </strong>
                .
              </li>

              <li>
                In the ID Card
                column, click the{' '}
                <strong>
                  BadgeIcon
                </strong>{' '}
                button.
              </li>

              <li>
                Select the
                students for whom
                you want to
                generate ID cards.
              </li>

              <li>
                Click{' '}
                <strong>
                  Generate ID Cards
                </strong>
                .
              </li>

              <li>
                The ID cards will
                generate and
                download
                automatically.
              </li>
            </ul>
          </CustomVerticalScrollbar>
        </Box>
      </Modal>

           {/* ======================================================
          SHARED THEME COLOR MODAL
          (used for both Admission PDF and ID Card)
      ====================================================== */}

      <Modal
        open={showThemeColorModal}
        onClose={() =>
          setShowThemeColorModal(false)
        }
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 350,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6">
              {pdfAction === 'idcard'
                ? `Generate ID Card - ${selectedAdmission?.candidate_name || ''}`
                : `Generate Admission PDF - ${selectedAdmission?.candidate_name || ''}`}
            </Typography>

            <IconButton
              onClick={() =>
                setShowThemeColorModal(false)
              }
              sx={{ p: 0.5 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography>PDF Color:</Typography>

            <SketchPicker
              color={tempThemeColor}
              onChangeComplete={(color) =>
                setTempThemeColor(color.hex)
              }
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <Button
              variant="outlined"
              onClick={() =>
                setTempThemeColor(pdfThemeColor)
              }
            >
              Reset
            </Button>

            <Button
              variant="contained"
              onClick={async () => {
                setShowThemeColorModal(false);

                if (pdfAction === 'idcard') {
                  await handleGenerateIDCard();
                } else {
                  await generateAdmissionPDF(
                    selectedAdmission,
                    tempThemeColor
                  );
                }
              }}
            >
              {pdfAction === 'idcard'
                ? 'Generate ID Card'
                : 'Generate PDF'}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default Admission;
